import React from 'react';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

import { Container } from '../common';
import { rem } from '../../styles/utils';
import { BgWaterproofMattressProtectorIntro } from '../assets';

const Section = styled.section`
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${media.md`
    flex-direction: column;
  `}
`;

const Info = styled.div`
  text-align: center;

  ${media.md`
    margin-bottom: 40px;
  `}
`;

const Headline = styled.h2`
  font-family: var(--font-header);
  color: var(--font-primary-color);
  font-size: ${rem(24)};
  font-weight: normal;

  ${media.md`
    margin-top: 0;
  `}

  ${media.lg`
    font-size: ${rem(38)};
  `}

  ${media.xl`
    font-size: ${rem(42)};
  `}
`;

const Body = styled.p`
  font-family: var(--font-body);
  color: var(--font-secondary-color);
  font-size: ${rem(12)};
  line-height: 1.3;
  font-weight: normal;

  ${media.md`
    max-width: 645px;
    margin-left: auto;
    margin-right: auto;
  `}

  ${media.lg`
    font-size: ${rem(16)};
  `}
`;

const ImgContainer = styled.div`
  width: 100%;
  height: 375px;

  ${media.md`
  height: 500px;
`}

  ${media.xl`
  height: 810px;
`}
`;

const Img = styled(BgWaterproofMattressProtectorIntro)`
  width: 100%;
  height: 100%;
`;

const WaterproofMattressProtectorIntroSection: React.FC = () => {
  return (
    <Section>
      <Container>
        <Wrapper>
          <Info>
            <Headline>Designed for worry-free sleep</Headline>
            <Body>
              Go ahead and sip on your pre-bedtime cuppa without fretting over
              spills. In the event of accidental topples, the top layer of the
              mattress protector absorbs all the liquid, keeping your mattress
              below 100% dry.
            </Body>
          </Info>
        </Wrapper>
      </Container>
      <ImgContainer>
        <Img />
      </ImgContainer>
    </Section>
  );
};

export default WaterproofMattressProtectorIntroSection;
